import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { withScriptLoader } from './common/uitk-eg-map-helper.esm.js';
import './types/uitk-eg-map-marker-type.esm.js';
import { UitkEGMapsContainer } from './components/uitk-eg-map-container.esm.js';
import 'uitk-react-loader';
import 'uitk-react-layout-position';
import '@eg-maps/core';
import 'uitk-react-utils';
import { UitkEGMapsType } from './types/uitk-eg-map-props.esm.js';

/**
 * Business-level eg-maps component.
 *
 */
var UitkEGMaps = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return withScriptLoader(React.createElement(UitkEGMapsContainer, __assign({}, rest), children), __assign({}, rest));
};
var defaultProps = {
    clustering: false,
    height: '100%',
    mapStyle: 'mapbox://styles/mapbox/streets-v10',
    mapType: UitkEGMapsType.GOOGLE,
    markerType: 'price',
    showPopup: false,
    width: '100%'
};
UitkEGMaps.defaultProps = defaultProps;

export { UitkEGMaps };
